export class GridSelectionState<T extends { id: number | string }> {
  selectedItems: T[] = [];
  allSelected = false;

  isSelected(id: number | string): boolean {
    return this.selectedItems.some(x => x.id === id);
  }

  toggle(row: T, allData: T[]): void {
    const index = this.selectedItems.findIndex(x => x.id === row.id);
    if (index > -1) {
      this.selectedItems.splice(index, 1);
    } else {
      this.selectedItems.push(row);
    }
    this.updateAllSelectedState(allData);
  }

  toggleAll(checked: boolean, allData: T[]): void {
    this.selectedItems = checked ? [...allData] : [];
    this.updateAllSelectedState(allData);
  }

  updateAllSelectedState(allData: T[]): void {
    this.allSelected = allData.length > 0 && allData.every(row => this.isSelected(row.id));
  }

  clear(): void {
    this.selectedItems = [];
    this.allSelected = false;
  }
}
